var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.5,
    height: 14,
    viewBox: "0 0 10.5 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "upload",
    d: "M10.117-9.57a1.266,1.266,0,0,1,.383.93V.438a1.266,1.266,0,0,1-.383.93,1.266,1.266,0,0,1-.93.383H1.313a1.266,1.266,0,0,1-.93-.383A1.266,1.266,0,0,1,0,.438V-10.937a1.267,1.267,0,0,1,.178-.656,1.338,1.338,0,0,1,.479-.479,1.267,1.267,0,0,1,.656-.178H6.891a1.266,1.266,0,0,1,.93.383ZM7-10.828V-8.75H9.078ZM9.188.438V-7.437H6.344a.633.633,0,0,1-.465-.191.633.633,0,0,1-.191-.465v-2.844H1.313V.438ZM5-6.016a.308.308,0,0,1,.492,0L7.465-4.047a.274.274,0,0,1,.082.342.3.3,0,0,1-.3.205H5.906v2.3a.316.316,0,0,1-.1.232.316.316,0,0,1-.232.1H4.922a.316.316,0,0,1-.232-.1.316.316,0,0,1-.1-.232V-3.5H3.254a.3.3,0,0,1-.3-.205.274.274,0,0,1,.082-.342Z",
    transform: "translate(0 12.25)",
    fill: "#8c8b97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.cdcf973dc45231b364c5dc979fcfff8b.svg";
export { ForwardRef as ReactComponent };